import React from "react";
import { format } from "date-fns-tz";

export interface DateTimeViewProps {
    value: Date;
}

const DateTimeView:React.FC<DateTimeViewProps> = ({ value }) => (<span>{format(value, 'yyyy-MM-dd HH:mm', { timeZone: 'Europe/Warsaw'  })}</span>)

export default DateTimeView;